/**
 * Textarea component — styled multi-line text input matching the platform design system.
 * Temporary implementation until dads-components exports Textarea.
 */

import { forwardRef } from 'react'
import { clsx } from 'clsx'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

/** Multi-line text input with theme-aware styling. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={clsx(
          'flex min-h-[80px] w-full rounded-lg border border-border bg-surface-input px-3 py-2',
          'text-sm text-content placeholder:text-content-tertiary',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'transition-colors duration-150',
          className,
        )}
        {...props}
      />
    )
  },
)

Textarea.displayName = 'Textarea'
